import React from 'react';

import { Button, ModalBody } from '@components';
import { useHistory } from 'react-router-dom';
import { FCWithChildren } from '@types';

type GuestIdentifiedPopupProps = {
  startHereSsid: string | null;
};

const GuestIdentifiedPopup: FCWithChildren<GuestIdentifiedPopupProps> = ({ startHereSsid }) => {
  const history = useHistory();
  return (
    <>
      <ModalBody>
        <div className="mb-2">
          <h2>Guest device not identified</h2>
        </div>
        <div className="mb-2">
          <h2>Please connect to Wi-Fi network {startHereSsid} to register.</h2>
        </div>
        <div>
          <Button
            layout="secondary"
            className="w-full sm:w-auto mt-3 p-2"
            size="lg"
            onClick={() => history.goBack()}
          >
            Cancel
          </Button>
        </div>
      </ModalBody>
    </>
  );
};
export default GuestIdentifiedPopup;
